import { Component, Input } from '@angular/core';

export type DocumentValidationState = 'idle' | 'loading' | 'valid' | 'invalid';

@Component({
  selector: 'app-document-validation-status',
  templateUrl: './document-validation-status.component.html',
  styleUrls: ['./document-validation-status.component.scss']
})
export class DocumentValidationStatusComponent {
  @Input() state: DocumentValidationState = 'idle';
  @Input() reason: string = '';
}
